// extracted by mini-css-extract-plugin
export default {"signup":"SignUpPage_signup__QvhFz","signupForm":"SignUpPage_signupForm__4+sMu","loginForm":"SignUpPage_loginForm__n-cIM","bottom":"SignUpPage_bottom__ZBKs4"};